import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  return <section className="relative w-full overflow-hidden border-y border-white/10 bg-ink-900 py-16 sm:py-20" aria-labelledby="metodo-title" data-id="element-75" data-mp="7tl8rg70s9wg">
      <div className="grid-texture absolute inset-0" aria-hidden="true" data-id="element-76" data-mp="2uif0rwhpq3s" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-14" data-id="element-77" data-mp="3uz2qyxdg2m1r">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.55
      }} data-id="element-78" data-mp="viebpwm27i0k">
          <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-amber-brand" data-id="element-79" data-mp="lr04f2nv9dwv">
            Presentamos
          </p>
          <h2 id="metodo-title" className="mt-3 font-display text-4xl font-bold uppercase leading-[1] text-white sm:text-5xl" data-id="element-80" data-mp="1e9xbzvop8hyw">
            El Método <span className="text-amber-brand" data-id="element-81" data-mp="19gue5bcw2mcw">Mecánica Inteligente</span>
          </h2>

          <div className="mt-6 space-y-5 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-82" data-mp="1v4btln7t402p">
            <p data-id="element-83" data-mp="203eoieu2opwy">
              No es un curso técnico aburrido para ser mecánico.{' '}
              <strong className="font-semibold text-white" data-id="element-84" data-mp="1lbwa2lgv33fp">
                Es un escudo protector para tu bolsillo.
              </strong>
            </p>
            <p data-id="element-85" data-mp="1cb7wtszal73v">
              Condensamos décadas de experiencia en una guía práctica y visual
              para que cualquier conductor, sin importar su edad o género, pueda
              entender su vehículo, realizar tareas básicas y hablarle de igual
              a igual a cualquier tallerista.
            </p>
            <p data-id="element-86" data-mp="17dpkrtpzabrn">
              Aprendé a escuchar a tu auto, a comprar repuestos como un experto
              y a mantener tu inversión protegida contra la inflación y los
              abusos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-950 shadow-2xl shadow-black/60" data-id="element-87" data-mp="31obfg6te7a53">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/50a6ed8c-6ad4-4ea7-8f6b-be5ce63bd0ab.jpg" alt="Manual Maestro de Mecánica Inteligente junto a las cinco guías de bonos en formato digital" className="h-full w-full object-cover" loading="lazy" data-id="element-88" data-mp="2ma8zfxjt2frt" />
        </motion.div>
      </div>
    </section>;
}